export const coloresEmpresas = {
  1: "#1e3a8a", // Hipergas
  2: "#1e3a8a", // Hipergas
  4: "#4c1d95", // Natural Gas
  5: "#881337", // Metalgar
  99: "#92400e", // Netizar
};